import { ChangeDetectorRef, Component, ChangeDetectionStrategy } from '@angular/core';
import { PinIdentityToDashboardModalViewModel } from '../../view-models/modal/pin-identity-to-dashboard-modal-view-model';
import { LabelledTextBoxComponent } from '../controls/labelled-text-box/labelled-text-box.component';
import type { ModalComponentInterface } from '@nts/std/interfaces';


@Component({
    selector: 'nts-pin-identity-to-dashboard-modal-container',
    templateUrl: 'pin-identity-to-dashboard-modal-container.component.html',
    styleUrls: ['./pin-identity-to-dashboard-modal-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        LabelledTextBoxComponent
    ]
})
export class PinIdentityToDashboardModalContainerComponent implements ModalComponentInterface {
    viewModel: PinIdentityToDashboardModalViewModel;

    public async initialize(): Promise<void> {
        await this.viewModel.initialize();
    }

    constructor(
        private cd: ChangeDetectorRef
    ) { }
}
